import { defaultText } from '../constants';
import { PollutantType } from './types';
import type { PollutantKey, PollutantsDataType } from './types';

export const getDominantPollutant = (dominantpollutant: keyof typeof PollutantType): string | undefined => {
    if (!dominantpollutant) {
        return defaultText;
    }

    switch (dominantpollutant) {
        case PollutantType.pm25:
            return 'PM2.5';
        case PollutantType.pm10:
            return 'PM10';
        case PollutantType.o3:
            return 'O\u2083';
        case PollutantType.co:
            return 'CO';
        case PollutantType.no2:
            return 'NO\u2082';
        case PollutantType.so2:
            return 'SO\u2082';
        default:
            return '';
    }
};

export const getGaugeFill = (pollutantsData: PollutantsDataType, pollutantType: PollutantKey, concentration?: number): number | undefined => {

    const pollutant = pollutantsData.find(pollutant => pollutant.apiField === pollutantType);

    if (!pollutant || !concentration) {
        return;
    }
    const range = pollutant.qualityRanges.find(
        range => concentration >= range.min && concentration < range.max
    );

    return range?.gaugeFill;
};

export const getGaugeColor = (gaugeFill?: number): string => {

    if (!gaugeFill && gaugeFill !== 0) {
        return '#AFAFAF';
    }
    if (gaugeFill < 20) {
        return '#58BE35';
    }
    if (gaugeFill < 40) {
        return '#C1E619';
    }
    if (gaugeFill < 60) {
        return '#FEC500';
    }
    if (gaugeFill < 80) {
        return '#FE4600';
    }
    return '#800000';
};

export const getFormattedValue = (gaugeValue: number): string | number | undefined  => {
    if (!gaugeValue && gaugeValue !== 0) {
        return;
    }
    if (gaugeValue > 999) {
        return (gaugeValue / 1000).toFixed(1) + 'K';
    }
    if (gaugeValue > 99) {
        return Math.round(gaugeValue);
    }
    if (gaugeValue > 9) {
        return parseFloat(gaugeValue as unknown as string).toFixed(1);
    }
    return parseFloat(gaugeValue as unknown as string).toFixed(2);
};